<div class="input-group" [ngClass]="size">
	<span class="input-group-btn">
    <button class="btn btn-primary" (mousedown)="fastSubtract()" (mouseup)="stopIntervals()" (mouseleave)="stopIntervals()" (click)="subtract()" [disabled]="rawValue <= min || block"><i class="fa fa-minus"></i></button>
  </span>
	<input type="text" class="form-control text-center" [value]="(nullValue === true ? '' : (value | number: '1.' + precision + '-' + precision)) + ' ' + append" disabled>
	<span class="input-group-btn">
    <button class="btn btn-primary" (mousedown)="fastAdd()" (mouseup)="stopIntervals()" (mouseleave)="stopIntervals()" (click)="add()" [disabled]="rawValue >= max || block"><i class="fa fa-plus"></i></button>
  </span>
</div>
